
export default (setAmbassadors: Function) => (ambassadorId: string) => {

  return setAmbassadors((ps: any) => ps.filter((item: any) => item._id !== ambassadorId));
}